import { Folder } from 'lucide-react';

interface DesktopIconProps {
  icon: React.ReactNode;
  label: string;
  onOpen: () => void;
}

export function DesktopIcon({ icon, label, onOpen }: DesktopIconProps) {
  return (
    <button
      onDoubleClick={onOpen}
      onClick={onOpen}
      className="group flex flex-col items-center gap-1 w-24 p-2 rounded-lg hover:bg-white/10 transition-colors"
      title={`Open ${label}`}
    >
      <div className="text-4xl group-hover:scale-110 transition-transform drop-shadow-lg">
        {icon}
      </div>
      <span
        className="text-xs text-white font-medium text-center px-1.5 py-0.5 rounded bg-black/30 group-hover:bg-black/50 transition-colors line-clamp-1"
        style={{ textShadow: '0 1px 2px rgba(0,0,0,0.8)' }}
      >
        {label}
      </span>
    </button>
  );
}